<template>
    <div class="relative min-h-full">
        <div v-show="open" class="fixed z-40 inset-0" @click="toggleDropdown"></div>

        <nav aria-label="Sidebar" :class="[installable ? 'top-24' : 'top-8']" class="sticky z-60 bg-gray-100 dark:bg-slate-900 divide-gray-300 dark:divide-slate-600 divide-y">
            <div v-show="open" class="absolute z-40 inset-0" role="none" @click="open = false"></div>

            <div class="pb-6 space-y-1" role="none" style="border-top-width: 0">
                <!-- User Dropdown -->
                <div v-if="$page.props.auth.check" class="mb-2 h-20 rounded-lg">
                    <div :class="{ 'shadow-xl absolute left-0 right-0 z-40 origin-top': open }" class="rounded-lg">
                        <button
                            :class="[open ? 'bg-white dark:bg-slate-800 rounded-t-lg rounded-b-none' : 'rounded-lg']"
                            class="group relative z-40 left-0 right-0 flex items-center justify-between mx-0 p-0.5 w-full h-20 hover:bg-white dark:hover:bg-slate-800 focus:outline-none origin-top transition duration-100 ease-in-out lg:p-1"
                            type="button"
                            @click="toggleDropdown"
                        >
                            <span class="flex items-center overflow-hidden space-x-3">
                                <span class="shrink-0">
                                    <avatar :alt="$page.props.user.name" :user="$page.props.user" class="w-10 h-10 xl:w-14 xl:h-14"></avatar>
                                </span>
                                <span class="flex flex-col grow text-left">
                                    <span class="w-full text-gray-700 dark:text-slate-200 text-sm font-medium truncate lg:text-base xl:text-lg">{{ $page.props.user.name }}</span>
                                    <span class="text-gray-600 dark:text-slate-100 text-xs truncate xl:text-sm">{{ $page.props.user.tag }}</span>
                                </span>
                            </span>
                            <div class="shrink-0">
                                <svg :class="[open ? 'group-focus:text-indigo-600 dark:group-focus:text-slate-300' : 'text-gray-400 dark:text-slate-400']" class="w-8 h-8 group-hover:text-indigo-500 dark:group-hover:text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path d="M8 9l4-4 4 4m0 6l-4 4-4-4" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                                </svg>
                            </div>
                        </button>

                        <!--
                            Dropdown menu, show/hide based on menu state.

                            Entering: "transition ease-out duration-100"
                              From: "transform opacity-0 scale-95"
                              To: "transform opacity-100 scale-100"
                            Leaving: "transition ease-in duration-75"
                              From: "transform opacity-100 scale-100"
                              To: "transform opacity-0 scale-95"
                            -->
                        <transition
                            enter-active-class="transition ease-out duration-100"
                            enter-class="transition-height"
                            enter-to-class="transform opacity-100 scale-100"
                            leave-active-class="transition ease-in duration-75"
                            leave-class="transform opacity-100 scale-100"
                            leave-to-class="transform opacity-0 scale-95"
                        >
                            <div v-show="open" aria-labelledby="options-menu-button" aria-orientation="vertical" class="z-40 -mt-px mx-0 pt-0.5 bg-white dark:bg-slate-800 rounded-b-lg focus:outline-none divide-gray-200 dark:divide-slate-600 divide-y origin-top" role="menu" tabindex="-1">
                                <div role="none">
                                    <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
                                    <Link :href="'/' + $page.props.user.tag" class="text-gray-700 hover:text-indigo-500 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="options-menu-item-0">View Profile </Link>
                                    <!--                                <Link :href="route('user.posts.list', 'published')" @click="open = false"-->
                                    <!--                                              class="text-gray-700 hover:text-indigo-700 hover:bg-gray-50 block px-4 py-2 text-sm"-->
                                    <!--                                              role="menuitem" tabindex="-1">Creator-->
                                    <!--                                </Link>-->

                                    <!--                                <Link :href="route('user.posts.list', 'published')" @click="open = false"-->
                                    <!--                                              class="text-gray-700 hover:text-indigo-700 hover:bg-gray-50 block px-4 py-2 text-sm"-->
                                    <!--                                              role="menuitem" tabindex="-1">Challenges-->
                                    <!--                                </Link>-->
                                    <!--<Link id="options-menu-item-2" :href="route('settings.show')" class="block px-4 py-2 text-gray-700 hover:text-indigo-700 text-sm hover:bg-gray-50" role="menuitem" tabindex="-1" @click="open = false">Challenges</Link>-->
                                    <!--<Link id="options-menu-item-2" href="/@clifton" class="block px-4 py-2 text-gray-700 dark:text-slate-400 hover:text-indigo-700 dark:hover:text-slate-300 text-sm hover:bg-gray-50 dark:hover:bg-slate-700" role="menuitem" tabindex="-1" @click="toggleDropdown"-->
                                    <!--    >View Profile</Link-->
                                    <!--&gt;-->
                                    <Link
                                        id="options-menu-item-2"
                                        :href="route('settings.show')"
                                        class="block px-4 py-2 text-gray-700 dark:text-slate-400 hover:text-indigo-700 dark:hover:text-slate-300 text-sm hover:bg-gray-50 dark:hover:bg-slate-700"
                                        role="menuitem"
                                        tabindex="-1"
                                        @click="toggleDropdown"
                                        >Settings</Link
                                    >
                                    <!--                                <Link href="#" @click="open = false"-->
                                    <!--                                              class="text-gray-700 hover:text-indigo-700 hover:bg-gray-50 block px-4 py-2 text-sm"-->
                                    <!--                                              role="menuitem" tabindex="-1" id="options-menu-item-3">Add Bank-->
                                    <!--                                </Link>-->
                                    <Link
                                        id="options-menu-item-3"
                                        v-if="$page.props.impersonating"
                                        :href="route('impersonate.leave')"
                                        class="block px-4 py-2 text-gray-700 dark:text-slate-400 hover:text-indigo-700 dark:hover:text-slate-300 text-sm hover:bg-gray-50 dark:hover:bg-slate-700"
                                        role="menuitem"
                                        tabindex="-1"
                                        @click="toggleDropdown"
                                        >End Impersonation</Link
                                    >
                                </div>

                                <!-- Logout -->
                                <Link
                                    id="options-menu-item-4"
                                    :href="route('logout')"
                                    as="button"
                                    class="group flex items-center justify-between px-4 py-3 w-full text-left text-gray-700 dark:text-slate-400 hover:text-indigo-700 dark:hover:text-slate-300 text-sm hover:bg-gray-50 dark:hover:bg-slate-700 rounded-b-lg focus:outline-none"
                                    method="post"
                                    role="menuitem"
                                    tabindex="-1"
                                    @click="toggleDropdown"
                                >
                                    <span>Logout</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-500 dark:text-slate-400 group-hover:text-indigo-700 dark:group-hover:text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                </Link>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- Home -->
                <sidebar-link :active="route().current('dashboard')" :href="route('dashboard')">
                    <span class="flex items-center">
                        <!-- Heroicon name: outline/home -->
                        <svg aria-hidden="true" class="flex-shrink-0 -ml-1 mr-3 w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Home</span>
                    </span>
                </sidebar-link>

                <!-- Trending -->
                <!--                <sidebar-link href="#">-->
                <!--                    <span class="flex items-center">-->
                <!--                        &lt;!&ndash; Heroicon name: outline/trending-up &ndash;&gt;-->
                <!--                        <svg class="stroke-current flex-shrink-0 -ml-1 mr-3 h-8 w-8" fill="none" viewBox="0 0 24 24">-->
                <!--                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />-->
                <!--                        </svg>-->
                <!--                        <span class="truncate">Trending</span>-->
                <!--                    </span>-->
                <!--                </sidebar-link>-->

                <!-- Competitions -->
                <!--                <sidebar-link :active="route().current('dashboard.competitions')"-->
                <!--                              :href="route('dashboard.competitions')">-->
                <!--                    <span class="flex items-center">-->
                <!--                        &lt;!&ndash; Heroicon name: outline/user-group &ndash;&gt;-->
                <!--                        <svg class="stroke-current flex-shrink-0 -ml-1 mr-3 h-8 w-8" fill="none" viewBox="0 0 24 24">-->
                <!--                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"-->
                <!--                                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>-->
                <!--                        </svg>-->
                <!--                        <span class="truncate">Competitions</span>-->
                <!--                    </span>-->
                <!--                </sidebar-link>-->

                <!-- Recent -->
                <sidebar-link :active="route().current('dashboard.recent')" :href="route('dashboard.recent')">
                    <span class="flex items-center">
                        <!-- Heroicon name: outline/clock -->
                        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" viewBox="0 0 24 24">
                            <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Recent</span>
                    </span>
                </sidebar-link>

                <!-- New Challenge Button -->
                <div class="pt-1">
                    <Link-button :href="route('posts.create')" class="w-full" color="brand">
                        <svg class="-ml-1 mr-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="M12 6v6m0 0v6m0-6h6m-6 0H6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>
                        New Challenge
                    </Link-button>
                </div>
            </div>

            <!-- Logged In -->
            <div v-if="$page.props.auth.check" class="pt-6 space-y-1">
                <!-- Notifications -->
                <!--                <sidebar-link :href="route('notifications.index')" :active="route().current('notifications.*')">-->
                <!--                    <span class="flex items-center">-->
                <!--                        <svg class="stroke-current flex-shrink-0 -ml-1 mr-3 h-8 w-8" fill="none" viewBox="0 0 24 24">-->
                <!--                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"-->
                <!--                                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>-->
                <!--                        </svg>-->
                <!--                        <span class="truncate">Notifications</span>-->
                <!--                    </span>-->
                <!--                    <span v-if="$page.props.user.unread_notifications_count" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 group-hover:shadow-sm has-tooltip">-->
                <!--                        {{ $page.props.user.unread_notifications_count | abbr }}-->
                <!--                        <tooltip>You have {{ $page.props.user.unread_notifications_count | toLocaleString }} unread notifications</tooltip>-->
                <!--                    </span>-->
                <!--                </sidebar-link>-->

                <!--Challenges-->
                <sidebar-link :active="route().current('posts.*')" :href="route('posts.published')">
                    <span class="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                            />
                        </svg>
                        <span class="truncate">My Challenges</span>
                    </span>
                    <!--<span v-if="$page.props.totalPendingCompetitors" class="has-tooltip inline-flex items-center px-2.5 py-0.5 text-yellow-800 text-sm font-medium bg-yellow-100 rounded-full group-hover:shadow-sm">-->
                    <!--    {{ $page.props.totalPendingCompetitors | abbr }}-->
                    <!--    <tooltip>You have {{ $page.props.totalPendingCompetitors | toLocaleString }} pending {{ "competitor" | pluralize($page.props.user.wallet.balance) }}</tooltip>-->
                    <!--</span>-->
                    <span v-if="$page.props.totalPendingCompetitors" class="has-tooltip inline-flex items-center relative px-2.5 py-0.5 text-sm font-medium bg-yellow-200 rounded-full group-hover:shadow-sm">
                        <!-- Animated Circle, positioned behind the text -->
                        <span class="flex absolute inset-0 z-0">
                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                            <!--<span class="absolute inline-flex rounded-full h-4 w-4 bg-yellow-100"></span>-->
                        </span>
                        <!-- Text, positioned above the animated circle -->
                        <span class="text-yellow-800 relative z-10">
                            {{ $page.props.totalPendingCompetitors | abbr }}
                        </span>
                        <tooltip class="z-10" v-if="$page.props.user.wallet">You have {{ $page.props.totalPendingCompetitors | toLocaleString }} pending {{ "competitor" | pluralize($page.props.user.wallet.balance) }}</tooltip>
                    </span>
                </sidebar-link>

                <!--Messenger-->
                <!--<sidebar-link :active="route().current('messenger.*')" :href="route('messenger.redirect')">-->
                <!--    <span class="flex items-center">-->
                <!--        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
                <!--            <path d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />-->
                <!--        </svg>-->
                <!--        <span class="truncate">Messages</span>-->
                <!--    </span>-->
                <!--    <span v-if="$page.props.user.unreadConversations" class="has-tooltip inline-flex items-center px-2.5 py-0.5 text-yellow-800 text-sm font-medium bg-yellow-100 rounded-full group-hover:shadow-sm">-->
                <!--        {{ $page.props.user.unreadConversations | abbr }}-->
                <!--        <tooltip>You have {{ $page.props.user.unreadConversations | toLocaleString }} unread {{ "conversation" | pluralize($page.props.user.unreadConversations) }}</tooltip>-->
                <!--    </span>-->
                <!--</sidebar-link>-->

                <!-- Wallet -->
                <sidebar-link :active="route().current('wallet.*')" :href="route('wallet.show')">
                    <span class="flex items-center">
                        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="m18 6h0h0q2 0 2 2v3h-2q-3 0-3 2t3 2h2v3q0 2-2 2h-14q-2 0-2-2v-12zm-16 0h16h-16q0-2 2-2h12q2 0 2 2q2 0 2 2v3q2 0 2 2q0 2-2 2q2 0 2-2q0-2-2-2v-3q0-2-2-2zzz" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Wallet</span>
                    </span>
                    <span v-if="$page.props.user.wallet && $page.props.user.wallet.balance" class="has-tooltip inline-flex items-center px-2.5 py-0.5 text-yellow-800 text-sm font-medium bg-yellow-200 rounded-full group-hover:shadow-sm">
                        {{ $page.props.user.wallet.balance | abbr }}
                        <tooltip>You have {{ $page.props.user.wallet.balance | toLocaleString }} {{ "token" | pluralize($page.props.user.wallet.balance) }}</tooltip>
                    </span>
                </sidebar-link>

                <!-- Buy Tokens -->
                <button @click="tryShowingBuyTokensModal" class="group flex items-center justify-between p-3 w-full hover:text-gray-500 dark:hover:text-gray-400 text-gray-600 dark:text-gray-500 hover:bg-white dark:hover:bg-slate-900 rounded-md focus:outline-none ring-0">
                    <span class="flex items-center">
                        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                            <path d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Buy Tokens</span>
                    </span>
                </button>
            </div>

            <!-- Logged Out -->
            <div v-if="!$page.props.auth.check" class="pt-6 space-y-1">
                <!-- Login -->
                <sidebar-link :active="route().current('login')" :href="route('login')">
                    <span class="flex items-center">
                        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" viewBox="0 0 24 24">
                            <path d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Login</span>
                    </span>
                </sidebar-link>

                <!-- Create Your Account -->
                <sidebar-link :active="route().current('register')" :href="route('register')">
                    <span class="flex items-center">
                        <svg class="flex-shrink-0 -ml-1 mr-3 w-8 h-8 stroke-current" fill="none" viewBox="0 0 24 24">
                            <path d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <span class="truncate">Create Your Account</span>
                    </span>
                </sidebar-link>
            </div>
        </nav>

        <app-footer />
    </div>
</template>

<script>
import LinkButton from "@/Components/Buttons/LinkButton"
import SidebarLink from "@/Components/Sidebar/SidebarLink"
import Tooltip from "@/Components/Tooltip"
import AppFooter from "@/Components/AppFooter"

export default {
    components: { AppFooter, Tooltip, SidebarLink, LinkButton },

    created() {
        const closeOnEscape = (e) => {
            if (this.open && e.keyCode === 27) {
                this.open = false
            }
        }

        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", closeOnEscape)
        })

        document.addEventListener("keydown", closeOnEscape)
    },

    watch: {
        open(bool) {
            this.$emit("update:show-overlay", bool)
        },
    },
    props: {
        installable: false,
    },

    data() {
        return {
            open: false,
            showBuyTokensModal: false,
        }
    },

    methods: {
        tryShowingBuyTokensModal() {
            this.verifyAuth().then((auth) => {
                if (auth) {
                    this.$root.$emit("showBuyTokensModal")
                } else {
                    this.$inertia.get(route("login"))
                }
            })
        },

        toggleDropdown() {
            this.open = !this.open
        },
    },
}
</script>
